import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'stripHtml',
    standalone: true,
})
export class StripHtmlPipe implements PipeTransform {
    transform (input: string | null | undefined): string {
        if (!input) {
            return '';
        }
        const div = document.createElement('div');
        div.innerHTML = String(input);
        const text = div.textContent || div.innerText || '';
        return text.trim();
    }
}
